import React from 'react';
import { AddCircleRounded as AddCircleRoundedIcon } from '@mui/icons-material';
import Box, { BoxProps } from '@mui/material/Box';
// import { CircularProgress } from '@mui/material';
import { Button, Typo } from 'components/primitives';

const EmptyRequest: React.FC<{ onCreate: () => void } & BoxProps> = ({ onCreate, ...props }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '300px',
      }}
      {...props}>
      <Box sx={{ textAlign: 'center' }}>
        <Typo variant='h4' color='textSecondary'>
          There is no request created yet
        </Typo>
        <Typo variant='h6' fontWeight={400} color='textSecondary'>
          Please use the button below to create an request
        </Typo>
        <Button
          sx={{ mt: 2, alignItems: 'center' }}
          startIcon={<AddCircleRoundedIcon />}
          onClick={onCreate}>
          Create Request
        </Button>
      </Box>
    </Box>
  );
};

export default EmptyRequest;
